import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=44052354"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44052354')) {
      api.createRecord('44052354', component.options)
    } else {
      api.reload('44052354', component.options)
    }
    module.hot.accept("./VSelect.vue?vue&type=template&id=44052354", function () {
      api.rerender('44052354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VSelect.vue"
export default component.exports